<template>
  <div class="mb-2 p-4 custom-form-bg">
    <validation-observer ref="purchaseApprovalmodel" novalidate tag="form">
      <div class="row">
        <div class="col-12 mb-3">
          <icon-view
            :has-border="false"
            icon="fas fa-check-circle text-orange"
            title="Información de Aprobación"
            variant="custom-icon-view"
            icon-background="white"
          />
        </div>
        <div class="col-12 col-md-3 mb-4">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-date-picker
              label="Fecha de Compra:"
              v-model="model.deliveryDate"
              placeholder="DD/MM/YYYY"
              class="custom-datetime-picker-approval-form"
              container-class="w-100"
              :error="errors[0]"
              custom-error-msg="La fecha es requerida"
              :disabled="true"
            />
          </validation-provider>
        </div>
        <div class="col-12 mb-4">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-text-area
              id="txtComment"
              :maxlength="3000"
              placeholder="Escribe un comentario"
              label="Comentario:"
              v-model="model.comment"
              :error="errors[0]"
              custom-error-msg="Este campo es requerido"
              :show-char-count="true"
              :count-classes="['d-block text-right']"
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="$emit('close')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="handlerSave"
      />
    </div>
  </div>
</template>
<script>
import ActionButton from "ActionButton";
import IconView from "icon-view";
import CustomTextArea from "CustomTextArea";
import CustomCallout from "custom-callout";
import CustomResultNotFound from "custom-result-not-found";
import CustomDatePicker from "custom-date-picker";
import inventoryOrderBooksService from "@/services/api/inventoryOrderBooks.api";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";

export default {
  name: "PurchaseApprovalForm",
  components: {
    ActionButton,
    IconView,
    CustomTextArea,
    CustomCallout,
    CustomResultNotFound,
    CustomDatePicker
  },
  mixins: [alertMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      model: {
        comment: "",
        deliveryDate: new Date()
      }
    };
  },
  computed: {},
  methods: {
    async handlerSave() {
      const isvalid = await this.$refs.purchaseApprovalmodel.validate();
      if (!isvalid) {
        this.ShowToast(
          "Alerta",
          "Por favor completa los campos requeridos.",
          "error"
        );
        return;
      }

      const confirmed = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro que desea guardar la información documentada?`,
        "Sí",
        "No"
      );

      if (!confirmed) return;

      const payload = {
        id: this.item.id,
        comment: this.model.comment,
        actionDate: this.model.deliveryDate
      };

      this.approveOrderPurchase(payload);
    },
    async approveOrderPurchase(payload) {
      await inventoryOrderBooksService.approveOrderPurchase(payload);
      this.$emit("saved");
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .custom-datetime-picker-approval-form .width-container {
  width: 100% !important;
}
.custom-form-bg {
  background-color: #f7f7f7;
  border-left: solid #ff7058;
  border-radius: 1%;
}
::v-deep .custom-datetime-picker-approval-form .fa.fa-calendar::before{
  content: "\f783";
  font-weight: 400;
}
</style>
